import K from '../constants/CategoriesConstants';
import axios from 'axios';

export const getCategories = () => {
    return dispatch => {
        const endpoint = `${process.env.REACT_APP_API_URL}/api/categories`;
        axios
            .get(endpoint)
            .then(function(response) {
                dispatch({
                    type: K.GET_CATEGORIES,
                    payload: response.data
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };
};

export const getCategory = slug => {
    return dispatch => {
        const filter = { where: { slug: slug } };
        const endpoint = `${
            process.env.REACT_APP_API_URL
        }/api/categories?filter=${JSON.stringify(filter)}`;
        axios
            .get(endpoint)
            .then(function(response) {
                dispatch({
                    type: K.GET_CATEGORY,
                    payload: response.data[0]
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };
};

export const clearCategory = () => {
    return dispatch => {
        dispatch({
            type: K.GET_CATEGORY,
            payload: {
                subcategories: []
            }
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/CategoriesActions.js